import { Box } from "@mui/material";
import { useLocales } from "../../../locales";
import { CommonWrap, ComomonAlert } from "../../common";
import Table from "../../../DocLayout/Table";
import ContentWrap from "../../../DocLayout/Content/Index";
import CodeSnippet from "../../../components/CodeSnippet";
import { codeMap } from "@/PageCodeComponents/MerchantUserWalletModeAPI";
import { useContext } from "react";
import { ChooseCodeLanguageContext } from "@/components/ChooseCodeLanguage/ChooseCodeLanguage";
import {
  CREATE_USER_DEPOSIT_ADDRESS,
  CREATE_USER_DEPOSIT_RECOED,
  CREATE_USER_DEPOSIT_RECOED_LIST,
} from "@/config";
import { Trans } from "react-i18next";
import PostRequest from "@/components/PostRequest";

export default function Index() {
  const { translate, currentLang } = useLocales();
  const { language } = useContext(ChooseCodeLanguageContext);
  let text_ = `${translate("merchant_user_wallet_mode_API.text_30")}` as any;
  if (currentLang.value !== "en") {
    text_ += `, ${translate("merchant_user_wallet_mode_API.text_32")}`;
  }
  return (
    <div>
      {/* 获取或创建用户地址 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="user-recharge-related-apis" className="title_0">
              {translate("merchant_user_wallet_mode_API.title_3")}
            </Box>
            <Box id="get-or-create-a-user-address" className="title_1">
              {translate("merchant_user_wallet_mode_API.title_3_1")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_1")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_2")}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={CREATE_USER_DEPOSIT_ADDRESS} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "userId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.request")}`,
                },
                {
                  name: "chain",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={codeMap["user_deposit_address"][language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取或创建用户地址 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "data.address",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_4")}`,
                },
                {
                  name: "data.memo",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_5")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_deposit_address"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/*Webhook 通知 - User Deposit  */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box id="webhook-notifications-user-deposit" className="title_1">
              {translate("merchant_user_wallet_mode_API.text_6")}
            </Box>
            <Box className="desc code">
              {currentLang.value === "en" ? (
                <Trans
                  i18nKey={"merchant_user_wallet_mode_API.text_7"}
                  t={translate as any}
                >
                  s
                  <a href={"#get-user-recharge-records"} className="link">
                    Just a placeholder
                  </a>
                </Trans>
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: translate(
                      "merchant_user_wallet_mode_API.text_7"
                    ) as any,
                  }}
                />
              )}
            </Box>
            <Box mt={3} className="title_1">
              {translate("merchant_user_wallet_mode_API.text_8")}
            </Box>
            <Table
              res
              tableData={[
                {
                  name: "recordId",
                  type: "String",
                  desc: translate("merchant_user_wallet_mode_API.text_14"),
                },
                {
                  name: "userId",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_id"
                  )}`,
                },
                {
                  name: "coinId",
                  type: "Integer",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "coinSymbol",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_symbol"
                  )}`,
                },
                {
                  name: "status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_9"
                        ) as any,
                      }}
                    />
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={`{
  "type": "UserDeposit",
  "msg": {
    "recordId": "202403130938151...",
    "userId": "6322718677975328",
    "coinId": 1329,
    "coinSymbol": "MATIC",
    "amount": "0.1",
    "status": "Success"
  }
}`}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户充值记录 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="get-user-recharge-records" className="title_1">
              {translate("merchant_user_wallet_mode_API.text_12")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_13")}
            </Box>

            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={CREATE_USER_DEPOSIT_RECOED} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "recordId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_14")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={codeMap["user_deposit_record"][language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户充值记录 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.record",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "data.userId",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_id"
                  )}`,
                },
                {
                  name: "data.record.recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_14")}`,
                },
                {
                  name: "data.record.coinId",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_34")}`,
                },
                {
                  name: "data.record.coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_35")}`,
                },
                {
                  name: "data.record.chain",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_36")}`,
                },
                {
                  name: "data.reocrd.contract",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_37")}`,
                },
                {
                  name: "data.record.fromAddress",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_17")}`,
                },
                {
                  name: "data.record.toAddress",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_18")}`,
                },
                {
                  name: "data.record.toMemo",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_19")}`,
                },
                {
                  name: "data.record.amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_20")}`,
                },
                {
                  name: "data.record.serviceFee",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_21")}`,
                },
                {
                  name: "data.record.txId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_22")}`,
                },
                {
                  name: "data.record.status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_23"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.record.arrivedAt",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_24")}`,
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_25"
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_deposit_record"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户充值历史记录 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="get-user-recharge-history" className="title_1">
              {translate("merchant_user_wallet_mode_API.text_26")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_27")}
            </Box>

            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={CREATE_USER_DEPOSIT_RECOED_LIST} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "coinId",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "userId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_id"
                  )}`,
                },
                {
                  name: "chain",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },
                {
                  name: "startAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_28"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "endAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_29"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "nextId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_30"
                        ) as any,
                      }}
                    />
                  ),
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_31"
                  ) as any,
                }}
              />
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_32"
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={codeMap["user_deposit_record_list"][language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户充值历史记录 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.records",
                  type: "Array",
                  desc: "",
                },
                {
                  name: "data.userId",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_id"
                  )}`,
                },
                {
                  name: "data.records[index].recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_14")}`,
                },
                {
                  name: "data.records[index].coinId",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_34")}`,
                },
                {
                  name: "data.records[index].coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_35")}`,
                },
                {
                  name: "data.records[index].chain",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_36")}`,
                },
                {
                  name: "data.records[index].contract",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_37")}`,
                },
                {
                  name: "data.records[index].fromAddress",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_17")}`,
                },
                {
                  name: "data.records[index].toAddress",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_18")}`,
                },
                {
                  name: "data.records[index].toMemo",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_19")}`,
                },
                {
                  name: "data.records[index].amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_20")}`,
                },
                {
                  name: "data.records[index].serviceFee",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_21")}`,
                },
                {
                  name: "data.records[index].txId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_22")}`,
                },
                {
                  name: "data.records[index].status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_23"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.records[index].arrivedAt",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_24")}`,
                },
                {
                  name: "nextId",
                  type: "String",
                  desc: (
                    <div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: text_,
                        }}
                      />
                    </div>
                  ),
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_31"
                  ) as any,
                }}
              />
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_32"
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_deposit_record_list"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
    </div>
  );
}
